import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import Config from '../../../config.json';
import { useLessonContext } from '../../../hooks';
import { fetchPost } from '../../../utils/fetch-utils';
import RatingStars from '../../rating-stars/rating-stars';
import ThemedText2 from '../../themed-text-2';

interface LessonRatingProps {
  lessonId: number;
  personId: number;
  onRating?: () => void;
}

const LessonRating: React.FC<LessonRatingProps> = ({
  lessonId,
  personId,
  onRating,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const hasBeenRated = rating > 0;
  const { environment } = useLessonContext();
  const ratingUrl = useMemo(
    () =>
      `${Config[environment].wolverineServiceUrl}/course/rate/${personId}/${lessonId}`,
    [environment, lessonId, personId]
  );

  useEffect(() => {
    if (!rating) {
      return;
    }

    if (onRating) {
      onRating();
    }

    fetchPost(`${ratingUrl}/${rating}`, {}).catch((error) =>
      console.error(error)
    );
  }, [rating, ratingUrl, onRating]);

  return (
    <>
      {!hasBeenRated && (
        <ThemedText2 style={styles.preRatingText}>
          {t('sectionComplete.ratingTitle')}
        </ThemedText2>
      )}
      <RatingStars value={rating} onChange={(value) => setRating(value)} />
      {hasBeenRated && (
        <ThemedText2 style={styles.postRatingText}>
          {t('sectionComplete.ratingCongrats')}
        </ThemedText2>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  preRatingText: {
    marginTop: 10,
    textAlign: 'center',
  },
  postRatingText: {
    textAlign: 'center',
  },
});

export default LessonRating;
